import { Box, BoxProps } from '@mui/material'

export const Card: React.FC<BoxProps> = ({ children, sx, ...props }) => {
  return (
    <Box
      sx={{
        p: 4,
        display: 'flex',
        borderRadius: '16px',
        flexDirection: 'column',
        backgroundColor: 'common.white',
        boxShadow: '0px 0px 2px rgba(64, 64, 64, 0.1), 0px 6px 15px -4px rgba(64, 64, 64, 0.14)',
        ...sx
      }}
      {...props}
    >
      {children}
    </Box>
  )
}
